import React from 'react'

const techStack = [
  // Row 1
  { name: "Python",           icon: { type: "img", src: "https://cdn.simpleicons.org/python" } },
  { name: "JavaScript",       icon: { type: "devicon", cls: "devicon-javascript-plain colored" } },
  { name: "TypeScript",       icon: { type: "devicon", cls: "devicon-typescript-plain colored" } },
  { name: "Swift",            icon: { type: "devicon", cls: "devicon-swift-plain colored" } },
  // Row 2
  { name: "Robot Framework",  icon: { type: "img", src: "https://cdn.simpleicons.org/robotframework" } },
  { name: "React",            icon: { type: "devicon", cls: "devicon-react-original colored" } },
  { name: "Playwright",       icon: { type: "devicon", cls: "devicon-playwright-plain colored" } },
  { name: "XCUITest",         icon: { type: "devicon", cls: "devicon-xcode-plain colored" } },
]

function TechIcon({ icon }) {
  if (icon.type === "img") {
    return <img src={icon.src} alt="" className="w-10 h-10 block" />
  }
  return <i className={`${icon.cls} text-[2.4rem] leading-none block`}></i>
}

export default function TechStack() {
  return (
    <div className="pb-10">
      <p className="text-sm font-bold tracking-widest text-title mb-6">STACK</p>
      <div className="flex justify-between">
        {techStack.map(({ name, icon }) => (
          <div key={name} className="relative group">
            <div className="w-[75px] h-[75px] flex items-center justify-center rounded-2xl bg-surface group-hover:scale-110 group-hover:shadow-md transition-all duration-200 cursor-default">
              <TechIcon icon={icon} />
            </div>
            <span className="absolute -bottom-9 left-1/2 -translate-x-1/2 whitespace-nowrap text-[0.7rem] font-semibold tracking-wide text-title bg-white border border-gray-200 rounded-lg px-2.5 py-1 shadow-md opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none after:content-[''] after:absolute after:-top-1 after:left-1/2 after:-translate-x-1/2 after:border-4 after:border-transparent after:border-b-white">
              {name}
            </span>
          </div>
        ))}
      </div>
    </div>
  )
}
